const Information = () => import('./Information.vue')
const PostersHaibao = () => import('./PostersHaibao.vue')
const PostersThr = () => import('./PostersThr.vue')
const Message = () => import('./Message.vue')
const PostersRedict = () => import('./PostersRedict.vue')
const Institute = () => import('./Institute.vue')
export {
  Information,
  PostersThr,
  PostersHaibao,
  Message,
  PostersRedict,
  Institute
}



// WEBPACK FOOTER //
// ./src/pages/information/index.js